import { clientDb, clientStorage, keyGen } from '../firebase';
import { UserAuth } from '../interfaces';
import { makeAudit } from '../helpers';

export interface iKmlFile {
    id: string;
    name: string;
    url: string;
    isVisible: boolean;
    createdAt: number;
    size: number;
}

const kmlDb = () => clientDb().child('kml-files');

export const uploadKml = (user: UserAuth) => async (file: File) => {
    const fileId = keyGen();
    if (!fileId) throw new Error("Failed to generate KML ID");

    const storageRef = clientStorage().child(`kml/${fileId}.kml`);

    const snapshot = await storageRef.put(file);
    const downloadUrl = await snapshot.ref.getDownloadURL();

    const newKmlFile: iKmlFile = {
        id: fileId,
        name: file.name,
        url: downloadUrl,
        isVisible: true,
        createdAt: Date.now(),
        size: file.size
    };

    const changes = {
        [`kml-files/${fileId}`]: newKmlFile
    };

    await clientDb().update(makeAudit(user, changes));

    return newKmlFile;
};

export const toggleKmlVisibility = (user: UserAuth) => async (fileId: string, isVisible: boolean) => {
    const changes = {
        [`kml-files/${fileId}/isVisible`]: isVisible
    };

    await clientDb().update(makeAudit(user, changes));
};

export const deleteKml = (user: UserAuth) => async (fileId: string) => {
    try {
        const storageRef = clientStorage().child(`kml/${fileId}.kml`);
        await storageRef.delete();
    } catch (error) {
        console.warn(`File ${fileId} not found in storage or already deleted`, error);
    }

    const changes = {
        [`kml-files/${fileId}`]: null
    };

    await clientDb().update(makeAudit(user, changes));
};

export const watchKmlFiles = (callback: (files: { [id: string]: iKmlFile }) => void) => {
    const ref = kmlDb();

    const handler = (snapshot: any) => {
        callback(snapshot.val() || {});
    };

    ref.on('value', handler);

    return () => ref.off('value', handler);
};